import ModalTemplate, {modalPageDecorator} from "./ModalTemplate";

export default modalPageDecorator({
  render(h) {
    return (
      <ModalTemplate>
        <div class="m-2 lg:my-12">
          <div class="bg-white container md:max-w-xl mx-auto rounded shadow-lg relative z-50">
            <div class="bg-gray-200 py-5 relative">
              <div class="cursor-pointer z-50 absolute left-0 top-0 m-5">
                <i class="mdi mdi-close text-3xl lg:text-4xl leading-none"></i>
              </div>
              <div class="w-11/12 lg:w-8/12 mx-auto">
                <h3 class="font-bold text-2xl mt-10 lg:mt-0 text-center">
                  {this.$t('profile_edit_page.reset_password')}
                </h3>
              </div>
            </div>

            <div class="w-11/12 lg:w-8/12 mx-auto">
              <div class="py-5">
                <p class="text-center mb-5">
                  {this.$t('profile_edit_page.reset_success_response')}
                </p>

                <button
                  class="block mx-auto px-5 p-2 lg:p-3 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none "
                  type="button" onClick={this.dismiss}>
                  {this.$t('continue_')}
                  <i class="mdi mdi-arrow-right ml-5"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalTemplate>
    );
  }
})